import { Controller } from "stimulus";

export default class extends Controller {

  static get targets() {
    return ["checkbox", "input"];
  }

  connect() {
    this.checkboxTargets.forEach((checkbox) => {
      this.toggleInput(checkbox);
    });
  }

  toggle(event) {
    this.toggleInput(event.target);
  }

  toggleInput(checkbox) {
    const input = this.inputTargets.find((input) => input.dataset.id === checkbox.dataset.id);

    if (!input) return;

    if (checkbox.checked) {
      input.classList.remove("dn");
    } else {
      input.classList.add("dn");
    }
  }

  handleSubmit() {
    this.checkboxTargets.forEach((checkbox) => {
      const input = this.inputTargets.find((input) => input.dataset.id === checkbox.dataset.id);

      if (!checkbox.checked) {
        input.querySelector("input").value = "";
      }
    });
  }
}
